/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore'], function(backbone, _) {
    var StartFileModel;
    return (StartFileModel = backbone.Model.extend(
        {
            defaults: {
                type: null,
                filter: null,
                url: null
            },

            /**
             * @param {Object} options
             * @returns {StartFileModel}
             */
            fromDTO: function(options) {
                var _this = this;
                _.each(StartFileModel.DTOMap, function(mappedName, attributeName) {
                    if (options[mappedName] !== undefined) {
                        _this.set(attributeName, options[mappedName]);
                    }
                });
                return this;
            }
        },
        {
            DTOMap: {
                type: 'type',
                filter: 'filter',
                url: 'url'
            }
        }
    ));
});
